module.exports = __webpack_public_path__ + "media/images/banner/wowjapan/zh-hans-94c966340c0c084cdf9af97e29bc92f9.jpg";